var Input = require("enyo/Input"),
    kind  = require("enyo/kind");

require("app/ui/Input.less");

module.exports = kind(/** @lends  app.ui.Input.prototype */ {

    /**
     * @private
     */
    name: "app.ui.Input",

    /**
     * @private
     */
    kind: Input,

    /**
     * @private
     */
    classes: "app-ui-input",

    /**
     * The theme to use for this input.
     *
     * @type  {?string}
     * @public
     */
    theme: null,

    /**
     * The text that will display as tooltip and is used by screen readers.
     *
     * @type  {?string}
     * @public
     */
    tooltip: null,

    /**
     * @private
     */
    handlers: {
        ontap: "onTap"
    },

    /**
     * @method
     * @private
     */
    create: kind.inherit(function(sup) {
        return function() {
            sup.apply(this, arguments);
            this.themeChanged();
            this.tooltipChanged();
        };
    }),

    /**
     * Set theme classes based on current theme.
     *
     * @param  {string}  previousTheme  The previous theme
     * @private
     */
    themeChanged: function(previousTheme) {
        var currentTheme = this.get("theme"),
            baseClass    = "app-ui-input";

        if (previousTheme && previousTheme !== currentTheme) {
            this.removeClass(baseClass + "--" + previousTheme);
        }

        if (currentTheme && currentTheme !== previousTheme) {
            this.addClass(baseClass + "--" + currentTheme);
        }
    },

    /**
     * Set css flag in case of no icon
     *
     * @private
     */
    tooltipChanged: function() {
        this.setAttribute("title", this.get("tooltip") || null);
    },

    /**
     * @private
     */
    onTap: function() {
        var node = this.hasNode();

        if (node && document.activeElement && document.activeElement !== node) {
            node.focus();
        }
    }

});
